import { useState, useContext } from 'react';
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from '@mui/material';
import StudentForm from './StudentForm';
import FormContext from '../contexts/form/formContext';

const studentCount = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
  42, 43, 44, 45, 46, 47, 48, 49, 50,
];

const ITEM_HEIGHT = 43;
const ITEM_PADDING_TOP = 10;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StudentSelect = () => {
  const { addStudentCount, participants, studentCountValue } =
    useContext(FormContext);
  const [studentNum, setStudentNum] = useState('');

  const onChange = (e) => {
    setStudentNum(+e.target.value);
    addStudentCount(parseInt(e.target.value));
  };

  return (
    <>
      <div className="my-6">
        <h4 className="text-2xl font-medium my-3">
          STUDENT(S) PASSPORT UPLOAD
        </h4>
        <FormControl
          className={
            'w-full cursor-pointer bg-slate-50 py-3 rounded-lg flex justify-between px-4'
          }
        >
          <InputLabel id="demo-multiple-name-label">
            Select no of student(s) to upload passport
          </InputLabel>
          <Select
            disabled={
              participants.length === studentCountValue &&
              participants.length !== 0
            }
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            className={'bg-slate-50 rounded-md border-none'}
            value={studentNum}
            onChange={onChange}
            input={
              <OutlinedInput label="Select number of student(s) to register" />
            }
            MenuProps={MenuProps}
          >
            {studentCount.map((count) => (
              <MenuItem key={count} value={count}>
                {count}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <br /> */}
        <StudentForm />
      </div>
    </>
  );
};

export default StudentSelect;
